import React from 'react';
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";

// คอมโพเนนต์สำหรับหัวข้อรูปลูกศร
const ArrowTitle = ({ children, className = "" }) => (
    <div
        className={`bg-[#d4a353] text-[#2c4021] font-bold text-lg md:text-xl py-2 px-6 shadow-md inline-flex items-center rounded-l-lg mb-4 relative z-10 ${className}`}
        style={{ clipPath: 'polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%)', paddingRight: '2.5rem' }}
    >
        {children}
    </div>
);

const VolunteerHistoryPage = () => {
    return (
        <div className="min-h-screen bg-[#f3ebd8] text-[#4a3320] font-sans">
            <SiteHeader />

            <main className="p-4 md:p-10 max-w-7xl mx-auto overflow-hidden">

                {/* ส่วนหัว Title (กล่องโค้งมน) */}
                <section className="text-center mb-10 bg-[#eedfc4] rounded-[2rem] p-6 md:p-8 shadow-sm max-w-5xl mx-auto border-[3px] border-[#e1cbad]">
                    <h1 className="text-2xl md:text-4xl font-extrabold text-[#5c4033] leading-snug mb-2">
                        โครงการอาสาสมัครท้องถิ่นในการดูแลรักษา
                    </h1>
                    <h2 className="text-xl md:text-3xl font-extrabold text-[#5c4033] mb-2">
                        มรดกทางศิลปวัฒนธรรม (อส.มศ.)
                    </h2>
                    <h3 className="text-lg md:text-2xl text-[#2c4021] font-bold">
                        ด้านเอกสารโบราณของกรมศิลปากร กระทรวงวัฒนธรรม
                    </h3>
                </section>

                {/* ส่วนเนื้อหาหลัก แบ่ง 2 คอลัมน์ และมีเส้นประตรงกลาง */}
                <div className="relative grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 pt-4">

                    {/* เส้นประและจุดตรงกลาง (แสดงเฉพาะหน้าจอใหญ่) */}
                    <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0 border-l-[3px] border-dashed border-[#5c4033] -translate-x-1/2 z-0">
                        {/* จุดวงกลมตกแต่งบนเส้นประ */}
                        <div className="absolute top-[5%] -left-[10px] w-5 h-5 bg-[#5c4033] rounded-full"></div>
                        <div className="absolute top-[35%] -left-[10px] w-5 h-5 bg-[#5c4033] rounded-full"></div>
                        <div className="absolute top-[65%] -left-[10px] w-5 h-5 bg-[#5c4033] rounded-full"></div>
                        <div className="absolute top-[90%] -left-[10px] w-5 h-5 bg-[#5c4033] rounded-full"></div>
                    </div>

                    {/* === คอลัมน์ซ้าย === */}
                    <div className="flex flex-col space-y-8 relative z-10">
                        {/* บทนำ */}
                        <p className="text-md md:text-lg leading-relaxed indent-8">
                            โครงการอาสาสมัครท้องถิ่นในการดูแลรักษามรดกทางศิลปวัฒนธรรม (อส.มศ.) จัดตั้งขึ้นเป็นครั้งแรกในปี พ.ศ. 2532 โดยกรมศิลปากรต้องการสรรหาบุคคลที่มีความรัก หวงแหน เห็นคุณค่าของโบราณสถาน โบราณวัตถุ มรดกศิลปวัฒนธรรม และมีจิตใจที่เสียสละ เข้ามาเป็นอาสาสมัครช่วยสอดส่อง ตรวจสอบ และดูแลรักษาโบราณสถานในเบื้องต้นร่วมกับ กรมศิลปากร
                        </p>

                        {/* อส.มศ. คือใคร ? */}
                        <div>
                            <ArrowTitle>อส.มศ. คือใคร ?</ArrowTitle>
                            <div className="ml-4 space-y-2 text-lg font-bold text-[#1f2882]">
                                <div className="flex items-center">
                                    <span className="w-12">อส.</span>
                                    <span className="text-red-600 mx-2">➔</span>
                                    <span className="text-[#4a3320] font-normal">อาสาสมัคร</span>
                                </div>
                                <div className="flex items-center">
                                    <span className="w-12">มศ.</span>
                                    <span className="text-red-600 mx-2">➔</span>
                                    <span className="text-[#4a3320] font-normal">มรดกศิลปวัฒนธรรม</span>
                                </div>
                            </div>
                            <p className="mt-4 text-md md:text-lg leading-relaxed">
                                <span className="text-[#1f2882] font-bold">อส.มศ.</span> = อาสาสมัครท้องถิ่น ผู้เป็นตัวแทนของชุมชนในการดูแลรักษาโบราณสถาน โบราณวัตถุ ศิลปวัตถุใน ท้องถิ่น รวมทั้งเป็นผู้ประสานงานด้านการอนุรักษ์มรดกศิลปวัฒนธรรมที่อยู่ในภารกิจของกรมศิลปากรด้วย         ความเสียสละ
                            </p>
                        </div>

                        {/* ป้ายด้านเอกสารโบราณ */}
                        <div className="pt-4">
                            <div className="relative mt-2 mb-2">
                                {/* 1. เลเยอร์พื้นหลังสีทอง (แยกออกมาเพื่อรับ clipPath จะได้ไม่ไปตัดโดนโลโก้) */}
                                <div
                                    className="absolute inset-0 bg-gradient-to-r from-[#d4a353] to-[#e8c678] rounded-l-full shadow-md"
                                    style={{ clipPath: 'polygon(0% 0%, 95% 0%, 100% 50%, 95% 100%, 0% 100%)' }}
                                ></div>

                                {/* 2. เลเยอร์เนื้อหา ให้อยู่ด้านบน (z-10) */}
                                <div className="relative z-10 flex items-center py-3 px-4">

                                    {/* 3. วงกลมสีขาว (ตั้งค่าขนาดตายตัว และเป็น relative เพื่อล็อคตำแหน่งรูป) */}
                                    <div className="relative bg-white rounded-full w-14 h-14 mr-3 shrink-0 flex justify-center items-center shadow-inner">

                                        {/* 4. โลโก้ของคุณ (เอา rounded-full ออก เป็น absolute แล้วใช้ -top ดันขึ้นไป) */}
                                        <img
                                            src="../AboutPage/History.png"
                                            alt="Logo"
                                            className="absolute -top-3 w-16 max-w-none object-contain drop-shadow-md"
                                        />
                                    </div>

                                    <div className="text-center w-full pr-6 text-[#2c4021] font-bold text-lg md:text-xl leading-tight">
                                        อส.มศ. ด้านเอกสารโบราณ <br /> ของกรมศิลปากร
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* แกลลอรี่ สำรวจและอนุรักษ์เอกสารโบราณ */}
                        <div className="mt-8">
                            <h4 className="text-center font-bold text-lg mb-4">สำรวจและอนุรักษ์เอกสารโบราณ</h4>
                            <div className="grid grid-cols-2 gap-2">
                                <img src="../volunteer-history/1.jpg" alt="สำรวจ 1" className="w-full aspect-[2/1] object-cover rounded shadow-sm border-2 border-white" />
                                <img src="../volunteer-history/2.jpg" alt="สำรวจ 2" className="w-full aspect-[2/1] object-cover rounded shadow-sm border-2 border-white" />
                                <img src="../volunteer-history/3.jpg" alt="สำรวจ 3" className="w-full aspect-[2/1] object-cover rounded shadow-sm border-2 border-white" />
                                <img src="../volunteer-history/4.jpg" alt="สำรวจ 4" className="w-full aspect-[2/1] object-cover rounded shadow-sm border-2 border-white" />
                                <img src="../volunteer-history/5.jpg" alt="สำรวจ 5" className="w-full aspect-[2/1] object-cover rounded shadow-sm border-2 border-white" />
                                <img src="../volunteer-history/6.jpg" alt="สำรวจ 6" className="w-full aspect-[2/1] object-cover rounded shadow-sm border-2 border-white" />
                            </div>
                        </div>
                    </div>

                    {/* === คอลัมน์ขวา === */}
                    <div className="flex flex-col space-y-8 relative z-10 md:pt-12">

                        {/* อส.มศ. ทำอะไร ? */}
                        <div>
                            <ArrowTitle>อส.มศ. ทำอะไร ?</ArrowTitle>
                            <ul className="ml-6 list-disc text-md md:text-lg leading-relaxed space-y-3 marker:text-[#5c4033]">
                                <li>รู้จักโบราณสถาน โบราณวัตถุในท้องถิ่นของตนเอง</li>
                                <li>สอดส่อง ดูแลรักษา แจ้งข่าวเหตุการณ์ ความเสียหายที่จะเกิดขึ้นกับมรดกทางศิลปวัฒนธรรม</li>
                                <li>เผยแพร่ ประชาสัมพันธ์ข้อมูลเกี่ยวกับคุณค่าและ ความสำคัญของมรดกทางศิลปวัฒนธรรมให้ประชาชนเข้าใจมีความรักหวงแหนและเห็นคุณค่ามากยิ่งขึ้น</li>
                                <li>ประสานงานด้านการอนุรักษ์มรดกทางศิลปวัฒนธรรมระหว่างหน่วยงานและประชาชนในพื้นที่</li>
                            </ul>
                        </div>

                        {/* อส.มศ. จรรยาบรรณอย่างไร ? */}
                        <div className="pt-4">
                            <ArrowTitle>อส.มศ. <br /> จรรยาบรรณอย่างไร ?</ArrowTitle>
                            <p className="text-md md:text-lg leading-relaxed indent-8">
                                เสียสละ รู้คุณค่า โบราณสถาน โบราณวัตถุและ มรดกศิลปวัฒนธรรม มีความรับผิดชอบ มีความเข้มแข็งและอดทน มีคุณธรรมและซื่อสัตย์สุจริต มีจิตสำนึกใน การปกป้อง คุ้มครอง และอนุรักษ์มรดกวัฒนธรรม ของชาติ มีความรัก หวงแหนและภาคภูมิใจในเอกลักษณ์ของความเป็นไทย
                            </p>
                        </div>

                        {/* แกลลอรี่ ถ่ายทอดองค์ความรู้ */}
                        <div className="mt-8">
                            <h4 className="text-center font-bold text-lg mb-4">ถ่ายทอดองค์ความรู้ด้านเอกสารโบราณ</h4>
                            <div className="grid grid-cols-2 gap-2">
                                <img src="../volunteer-history/7.jpg" alt="สำรวจ 1" className="w-full aspect-[2/1] object-cover rounded shadow-sm border-2 border-white" />
                                <img src="../volunteer-history/8.jpg" alt="สำรวจ 2" className="w-full aspect-[2/1] object-cover rounded shadow-sm border-2 border-white" />
                                <img src="../volunteer-history/9.jpg" alt="สำรวจ 3" className="w-full aspect-[2/1] object-cover rounded shadow-sm border-2 border-white" />
                                <img src="../volunteer-history/10.jpg" alt="สำรวจ 4" className="w-full aspect-[2/1] object-cover rounded shadow-sm border-2 border-white" />
                                <img src="../volunteer-history/11.jpg" alt="สำรวจ 5" className="w-full aspect-[2/1] object-cover rounded shadow-sm border-2 border-white" />
                                <img src="../volunteer-history/12.jpg" alt="สำรวจ 6" className="w-full aspect-[2/1] object-cover rounded shadow-sm border-2 border-white" />
                            </div>
                        </div>
                    </div>

                </div>

                {/* รูปภาพใหญ่ด้านล่างสุด */}
                <div className="mt-12 relative z-10 max-w-6xl mx-auto">
                    <img src="../volunteer-history/13.jpg" alt="ภาพหมู่กิจกรรม" className="w-full h-auto object-cover rounded-lg shadow-md border-4 border-white" />
                </div>

            </main>

            <Footer />
        </div>
    );
};

export default VolunteerHistoryPage;